import e from "../managers/braze-instance.js";
import ir from "./feature-flags-provider-factory.js";
export function subscribeToFeatureFlagsUpdates(r) {
  if (!e.rr()) return;
  return ir.er().Ws(r);
}
